var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"text-nowrap"},[_c('span',{staticClass:"tags badge badge-primary"},[_vm._v(_vm._s(typeof item === "string" ? item : item[_vm.itemKey]))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }